(function (global) {
    var cookieConsent = {};

    cookieConsent.get = function () {
        return BeInteractive.cookieConsent.value;
    };

    cookieConsent.set = function (value) {
        return new Promise(function (resolve, reject) {
            $.post(
                "ajax/cookie-consent",
                JSON.stringify(value),
                function (data) {
                    BeInteractive.cookieConsent.value = data.value;
                    resolve(data);
                },
                "json"
            )
                .fail(function (jqXHR) {
                    reject(jqXHR);
                });
        });
    };

    cookieConsent.responded = function () {
        return this.get() !== null;
    };

    cookieConsent.accepted = function () {
        return this.responded() && this.get();
    };

    cookieConsent.denied = function () {
        return this.responded() && !this.get();
    };

    cookieConsent.getCookieName = function () {
        return BeInteractive.cookieConsent.cookie_name;
    };

    global.cookieConsent = cookieConsent;
})(window);
